import React, {
  Fragment,
  useState,
  useEffect,
  useRef,
  useMemo,
  useCallback,
} from "react";
import {
  getMlmfoutletMaster,
  getoutletListMaster,
  getCompanyListMaster,
  getDeliveryslotListMaster,
  getTemplatemsgMaster,
  getContactMasterReq,
  getOutletListMaster,
  AprovalpointREQ,
  downloadTemplateExcelDownload,
} from "../../../../apiservicescall/api";
import Table from "@mui/material/Table";
import { MuiThemeProvider, createMuiTheme } from "@material-ui/core/styles";
import MUIDataTable from "mui-datatables";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/Step";
import StepButton from "@material-ui/core/StepButton";
import RctCollapsibleCard from "../RctCollapsibleCard/RctCollapsibleCard";
import {
  // Table,
  Badge,
  Row,
  Card,
  Col,
  Button,
  Container,
  ListGroup,
  Tab,
} from "react-bootstrap";
import { Link } from "react-router-dom";
import Select from "react-select";
import { NotificationManager } from "react-notifications";
import {
  Pagination,
  PaginationItem,
  PaginationLink,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import swal from "sweetalert";
import { Form, FormGroup, Label, Input } from "reactstrap";
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Edit } from "@material-ui/icons";
import TemplateService from "./TemplateService";
import {
  // Stepper,
  // Step,
  // StepLabel,
  Typography,
  TextField,
  FormControl,
  InputLabel,
  MenuItem,
  CardContent,
  List,
} from "@mui/material";
import { TableRow, Tooltip } from "@material-ui/core";
import IconButton from "@material-ui/core/IconButton";
import {
  CloudDownload,
  FormatBold,
  TramRounded,
  CloudDownloadOutlined,
  ArrowDownward,
  ArrowDownwardRounded,
} from "@material-ui/icons";
import CloudUploadIcon from "@material-ui/icons/CloudUpload";
import Menu from "@material-ui/core/Menu";
import card from "./Card.css";
import Excelpage1 from "./ExcelUpload";

const Contact_master = () => {
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [totalItems, setTotalItems] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);

  const [list, setList] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);

  useEffect(() => {
    getContactmasterlist();
  }, []);

  const getContactmasterlist = async () => {
    
    let getlist = await getContactMasterReq();

    let getlistvalue = getlist?.data.data || [];
    console.log("getlistvalue", getlistvalue);

    setList(getlistvalue);
  };

  //   let actionOption = {
  //     name: "actions",
  //     label: "Actions",
  //     options: {
  //       filter: false,
  //       sort: false,
  //       customBodyRender: (summary, tableMeta, updateValue) => {
  //         return (
  //           <div className="list-action">
  //             <span
  //               style={{ color: "white", display: "flex" }}
  //               className="icon-top-left"
  //             >
  //               {/* <button
  //               type="button"
  //               className="rct-link-btn edit-btn"
  //               onClick={() => onEditUser(tableMeta)}
  //             >
  //               <i style={{ fontSize: "15px" }} className="ti-pencil"></i>
  //             </button> */}

  //               <Link
  //                 className=""
  //                 onClick={() => {
  //                   // setOutletDetails({})
  //                   approvalcall(tableMeta);
  //                 }}
  //                 // style={{ background: "#008000" }}
  //               >
  //                 <i
  //                   className="fas fa-pencil-alt fa-lg tpen-bck"
  //                   style={{
  //                     display: "flex",
  //                     alignItems: "center",
  //                     marginLeft: "1px",
  //                   }}
  //                 ></i>
  //               </Link>

  //               <Link
  //                 className=""
  //                 onClick={() => {
  //                   // setOutletDetails({})
  //                   viewDpoint(tableMeta);
  //                 }}
  //                 // style={{ background: "#008000" }}
  //               >
  //                 <i
  //                   className="fa fa-eye tpen-bck"
  //                   style={{ marginLeft: "3px" }}
  //                 ></i>
  //               </Link>
  //             </span>

  //             {/* <span style={{ paddingLeft: "20px",marginTop: "-20px" }} className="icon-top-left">

  //             <Link className="btn btn-primary shadow btn-xs sharp me-2"
  //               onClick={() => viewUser(tableMeta)} style={{ background: "#008000" }}
  //             >
  //               <i className="fa fa-eye"></i>
  //             </Link>
  //           </span> */}
  //           </div>
  //         );
  //       },
  //     },
  //   };

  const handleChangePage = (event, newPage) => {
    setCurrentPage(newPage);
  };

  const onChangeRowsPerPage = (numOfRows) => {
    // let { currentPage, itemsPerPage } = this.state;
    setItemsPerPage(numOfRows);
  };

  const handleClickMenuActiveInA = (event) => {
    console.log("event.currentTargget", event.currentTarget);
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = (event) => {
    if (event == "Y") {
      let val = "Y";
      exceltemplatedownload(val);
    } else if (event == "N") {
      let val = "N";
      exceltemplatedownload(val);
    } else {
    }
    setAnchorEl(null);
  };

  const exceltemplatedownload = async (val) => {
    //await this.setState({ reload: true });
    let sample = val;
    let downloadtemplateExcel = await downloadTemplateExcelDownload(sample);
    console.log("downloadtemplateExcel :>> ", downloadtemplateExcel);
    if (downloadtemplateExcel.status == 200) {
      NotificationManager.success("Downloaded");
      const url = window.URL.createObjectURL(
        new Blob([downloadtemplateExcel.data])
      ); // you can mention a type if you wish
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute(
        "download",
        `contact_Template_${new Date().getDate()}${
          new Date().getMonth() + 1
        }${new Date().getFullYear()}.xls`
      ); //this is the name with which the file will be downloaded
      link.click();
      // no need to append link as child to body.
      setTimeout(() => window.URL.revokeObjectURL(url), 0); // this is important too, otherwise we will be unnecessarily spiking memory!
      // await this.setState({ reload: false });
    } else {
      // await this.setState({ reload: false });
      NotificationManager.error("error", " error?.message");
    }
  };

  const options = {
    filter: true,
    search: true,
    selectableRows: false,
    responsive: "stacked",
    fixedHeader: true,
    tableBodyHeight: "60vh",
    fixedSelectColumn: true,
    page: currentPage,
    pagination: true,
    serverSide: false,
    rowsPerPage: itemsPerPage,
    rowsPerPageOptions: [10, 15, 100],
    onChangePage: (newPage) => {
      handleChangePage(newPage);
    },
    onChangeRowsPerPage: (numOfRows) => {
      onChangeRowsPerPage(numOfRows);
    },
    download: false,
    print: false,
    onFilterChange: (
      column,
      filterList,
      type,
      filterOptions,
      changedColumnIndex
    ) => {},
    confirmFilters: true,
    customFilterDialogFooter: (currentFilterList, applyNewFilters) => {
      return (
        <div style={{ marginTop: "40px" }}>
          <Button variant="contained" onClick={() => applyNewFilters()}>
            Apply Filters
          </Button>
        </div>
      );
    },
    onFilterConfirm: (filterList) => {
      // Handle filter confirmation here if needed
    },
    onFilterDialogOpen: () => {
      // Handle filter dialog open event if needed
    },
    onFilterDialogClose: () => {
      // Handle filter dialog close event if needed
    },
    customToolbar: () => {
      return (
        <>
          <Excelpage1 />

          <>
            <Tooltip title={"Excel Template"}>
              <IconButton>
                <CloudDownloadOutlined onClick={handleClickMenuActiveInA} />
              </IconButton>
            </Tooltip>

            <Menu
              id="simple-menu"
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={handleCloseMenu}
            >
              <MenuItem
                onClick={() => {
                  handleCloseMenu("Y");
                }}
              >
                New Template
              </MenuItem>
              <MenuItem
                onClick={() => {
                  handleCloseMenu("N");
                }}
              >
                Update
              </MenuItem>
            </Menu>
          </>
        </>
      );
    },
  };

  const columns = [
    {
      name: "firstName",
      label: "Name",
      options: {
        filter: true,
        sort: true,
        searchable: true,
        fixedHeader: true,
        responsive: "stacked",
        filterType: "textField",
      },
    },

    {
      name: "mobileNumber",
      label: "Mobile Number ",
      options: {
        filter: true,
        sort: true,
        searchable: true,
        fixedHeader: true,
        responsive: "stacked",
        filterType: "textField",
      },
    },

    {
      name: "mailId",
      label: "E-mail ",
      options: {
        filter: true,
        sort: true,
        searchable: true,
        customFilterListOptions: { render: (v) => `UID: ${v}` },
        fixedHeader: true,
        responsive: "stacked",
        filterType: "textField",
      },
    },

    {
      name: "city",
      label: "City ",
      options: {
        filter: true,
        sort: true,
        searchable: true,
        customFilterListOptions: { render: (v) => `UID: ${v}` },
        fixedHeader: true,
        responsive: "stacked",
        filterType: "textField",
      },
    },

    {
      name: "country",
      label: "Country ",
      options: {
        filter: true,
        sort: true,
        searchable: true,
        customFilterListOptions: { render: (v) => `UID: ${v}` },
        fixedHeader: true,
        responsive: "stacked",
        filterType: "textField",
      },
    },

    // actionOption,
  ];

  const themeTable = createMuiTheme({
    overrides: {
      MUIDataTable: {
        root: {
          backgroundColor: "#FF000",
        },
        paper: {
          boxShadow: "none",
        },
      },
      MuiTableRow: {
        root: {
          "&:nth-of-type(odd)": {
            backgroundColor: "white !important",
          },
          "&:nth-of-type(even)": {
            backgroundColor: "#e4e8ef !important",
          },
        },
      },

      MUIDataTableHeadCell: {
        root: {
          backgroundColor: "#008000 !important",
        },
        data: {
          fontWeight: "bold",
          color: "white",
          fontSize: "14px",
        },
      },
    },
  });

  return (
    <>
      <div className="row">
        <div className="col-md-12 col-lg-12 col-sm-12 col-xl-12 temp-crd">
          <Card>
            <div class="row ovrl-crd-hd">
              <div class="col-3 col-md-3 col-lg-3 ">
                <div class="form-group">
                  <h3 className="main-hd cs-main-hd">Contact Master</h3>
                </div>
              </div>
              <div
                class="col-9 col-md-9 col-lg-9 row"
                style={{ marginTop: "11px" }}
              >
                 

              </div>
            </div>

            <RctCollapsibleCard fullBlock>
              <RctCollapsibleCard fullBlock>
                <MuiThemeProvider theme={themeTable}>
                  <MUIDataTable
                    title={""}
                    data={list}
                    columns={columns}
                    options={options}
                    columOrder={columns}
                    className={"MuiTabCusCls"}
                  />
                </MuiThemeProvider>
              </RctCollapsibleCard>
            </RctCollapsibleCard>
          </Card>
        </div>
      </div>
    </>
  );
};

export default Contact_master;
